import Loader from "@druva-apps/orion/lib/loader";
import Page from "@druva-apps/orion/lib/page";
import { FC, lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Coralogix from "components/Coralogix";

import Navbar from "shared/Navbar";
const Accounts = lazy(
  () => import(/* webpackChunkName: "accounts" */ "./Accounts/Accounts")
);
const Account = lazy(
  () => import(/* webpackChunkName: "account" */ "./Account/Account")
);
const EduLicenseRequests = lazy(
  () =>
    import(
      /* webpackChunkName: "edu-license-requests" */ "./edu-license-requests"
    )
);
const Sidebar = lazy(
  () => import(/* webpackChunkName: "sidebar" */ "shared/sidebar")
);
const FBAccounts = lazy(
  () => import(/* webpackChunkName: "page" */ "./firebird/fbaccounts")
);
const FBAccountDetails = lazy(
  () => import(/* webpackChunkName: "page" */ "./firebird/fbAccountDetails")
);

const FBRateCards = lazy(
  () => import(/* webpackChunkName: "page" */ "./firebird/fbratecards")
);
const FBAuditTrails = lazy(
  () => import(/* webpackChunkName: "page" */ "./firebird/fbaudittrails")
);
const FBJobs = lazy(
  () => import(/* webpackChunkName: "page" */ "./firebird/fbjobs")
);

const App: FC = () => {
  return (
    <Suspense fallback={<Loader fullPage isLoading />}>
      <Coralogix />
      <Navbar brandName="Managed Services Center Support Portal" />
      <Page>
        <Sidebar />
        <Routes>
          <Route path="accounts" element={<Accounts />} />
          <Route path="accounts/:accountId" element={<Account />} />
          <Route path="firebird-accounts" element={<FBAccounts />} />
          <Route path="firebird-accounts/:accountId" element={<FBAccountDetails />} />
          <Route path="firebird-rate-cards" element={<FBRateCards />} />
          <Route path="firebird-rate-cards/:rateCardId" element={<FBRateCards />} />
          <Route path="firebird-audit-trails" element={<FBAuditTrails />} />
          <Route path="firebird-jobs" element={<FBJobs />} />
          <Route path="edu-license-requests" element={<EduLicenseRequests />} />
          <Route path="/" element={<Navigate replace to="accounts" />} />
        </Routes>
      </Page>
    </Suspense>
  );
};

export default App;
